import store from 'store';
import camelCase from 'lodash/camelCase';
import { getTranslatedString } from 'helpers/i18n';

/*****************************************************
 *
 * serviceRequestVerbiage
 * @returnType = 'translated', 'camelCase', 'capitalized', 'titlecase', 'plural', default: 'translated'
 *
 * @returns:
 * - camelcase version of the correct verbiage
 * - Translated version
 * - Capetalized, translated version
 * - Plural, translated version
 *
 */

export function _serviceRequestVerbiage(verbiages, returnType = 'translated') {
  let camelCaseVerbiage = 'serviceRequest';
  if (verbiages) {
    camelCaseVerbiage = camelCase(verbiages['serviceRequest']) || 'serviceRequest';
  }

  if (returnType === 'camelCase') {
    return camelCaseVerbiage;
  } else if (returnType === 'capitalized') {
    return getTranslatedString(`${camelCaseVerbiage}Capitalized`);
  } else if (returnType === 'titlecase') {
    return getTranslatedString(`${camelCaseVerbiage}Titlecase`);
  } else if (returnType === 'plural') {
    return getTranslatedString(`${camelCaseVerbiage}Plural`);
  } else {
    return getTranslatedString(camelCaseVerbiage);
  }
}

export function serviceRequestVerbiage(returnType = 'translated') {
  const { verbiages } = store.getState().userTypes;

  return _serviceRequestVerbiage(verbiages, returnType);
}

/*****************
 *
 * serviceRequestOptions
 * options: an object representing multiple strings to print dependent on the verbiage
 *
 * ex: options: {
 *  serviceRequest: "This is a service request",
 *  requestForMaintenance: "This is a request for maintenance"
 * }
 *
 *
 *
 */

export function _serviceRequestOptions(verbiages, options = {}) {
  let camelCaseVerbiage = 'serviceRequest';
  if (verbiages) {
    camelCaseVerbiage = camelCase(verbiages['serviceRequest']) || 'serviceRequest';
  }

  return options[camelCaseVerbiage];
}

export function serviceRequestOptions(options = {}) {
  const { verbiages } = store.getState().userTypes;

  return _serviceRequestOptions(verbiages, options);
}

/*****************************************************
 *
 * @returnType = 'translated', 'camelCase', 'capitalized', 'plural', default: 'translated'
 *
 * @returns:
 * - camelcase version of the correct verbiage
 * - Translated version
 * - Capetalized, translated version
 * - Plural, translated version
 *
 */

export function _getVerbiage(verbiages, verbiage, returnType = 'translated') {
  let camelCaseVerbiage = camelCase(verbiages[verbiage]) || verbiage;

  if (returnType === 'camelCase') {
    return camelCaseVerbiage;
  } else if (returnType === 'capitalized') {
    return getTranslatedString(`${camelCaseVerbiage}Capitalized`);
  } else if (returnType === 'plural') {
    return getTranslatedString(`${camelCaseVerbiage}Plural`);
  } else {
    return getTranslatedString(camelCaseVerbiage);
  }
}

export function getVerbiage(verbiage, returnType = 'translated') {
  const { verbiages } = store.getState().userTypes;

  return _getVerbiage(verbiages, verbiage, returnType);
}

/*****************
 *
 * options: an object representing multiple strings to print dependent on the verbiage
 *
 * ex: options: {
 *  serviceRequest: "This is a service request",
 *  requestForMaintenance: "This is a request for maintenance"
 * }
 *
 */

export function _getVerbiageOptions(verbiages, verbiage, options = {}) {
  let camelCaseVerbiage = camelCase(verbiages[verbiage]) || verbiage;

  return options[camelCaseVerbiage];
}

export function getVerbiageOptions(verbiage, options = {}) {
  const { verbiages } = store.getState().userTypes;

  return _getVerbiageOptions(verbiages, verbiage, options);
}
